import { Component, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import {
  BaseResourceListComponent, Exercicio, LoginPublico,
  ExercicioService, Filtro, Cargo, Coluna
} from 'eddydata-lib';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-transparencia-pesquisa',
  templateUrl: './transparencia-pesquisa.component.html'
})
export class TransparenciaPesquisaComponent extends BaseResourceListComponent<Exercicio, LoginPublico> {
  /**
   * Declaração de variáveis
   */
  public data1: string;
  public data2: string;
  public datepipe: DatePipe;
  public listaGeral = [];
  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    private route: ActivatedRoute,
    protected injector: Injector,
    private exService: ExercicioService) {
    super(exService, injector);
    this.datepipe = new DatePipe('pt');
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'cidade';
  }

  protected condicoesGrid(): {} {
    return {
      ['cidade.id']: this.login.cidade.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['id$ASC'];
  }

  protected filtrosGrid(): Filtro {
    return {
    };
  }

  protected afterInit(): void {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
    const dt1 = new Date(`01/01/${new Date().getFullYear()}`);
    const dt2 = new Date();
    this.data1 = this.datepipe.transform(dt1, 'yyyy-MM-dd', 'GMT');
    this.data2 = this.datepipe.transform(dt2, 'yyyy-MM-dd', 'GMT');
    this.route.params.pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        const filtro = params.filtro;
        this.exService.pesquisarTransparenciaGeral(filtro, this.login.exercicio.id, this.login.orgao.id)
          .subscribe(res => {
            this.listaGeral = res;
          });
      });
  }

  protected acaoRemover(model: Cargo): Observable<Cargo> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
    ];
  }

  public imprimirPDF() {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public buscar(item: any) {
    switch (item.tipo) {
      case 'empenho':
        this.router.navigate(['/transparencia/empenhos-orcamentarios/visualiza', item.id, 'todos', 1, this.data1, this.data2]);
        break;
      case 'contrato':
        this.router.navigate(['/transparencia/contratos/visualiza', item.id, 1, this.data1, this.data2]);
        break;
      case 'remuneracao':
        this.router.navigate(['/transparencia/folha-pagamento/visualiza', item.id, 1, this.login.exercicio.ano, 'TODOS']);
        break;
      default:
        break;
    }
  }
}
